import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PasswordAction from '../actions/PasswordAction';
import ResetPassword from '../../components/ResetPassword/ResetPassword';

const mapStateToProps = (state, ownProps) => ({
  token: ownProps.location.query.token,
  password: state.form.resetPassword.values.password
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    verifyToken: PasswordAction.verifyToken,
    submitResetPassword: PasswordAction.submitResetPassword
  }, dispatch);


const ResetPasswordContainer = connect(mapStateToProps, mapDispatchToProps)(ResetPassword);

export default ResetPasswordContainer;



/** WEBPACK FOOTER **
 ** ./src/redux/containers/ResetPasswordContainer.js
 **/